import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import StringInput from '../../../../components/inputs/StringInput'
import { GeneralContactFormFields } from '../GeneralContactModal'

interface AdditionalDetailsStepProps {
	form: UseFormReturn<GeneralContactFormFields>
}

const AdditionalDetailsStep: React.FC<AdditionalDetailsStepProps> = ({ form }) => {
	const { t } = useTranslation('modals_generalContact')
	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
			<div className='text-xs text-text-dark dark:text-white'>{t('detailsStep.description')}</div>
			<Controller
				control={form.control}
				name={'additionalDetails'}
				defaultValue=''
				render={({ field }) => (
					<StringInput
						value={field.value}
						onChange={field.onChange}
						multiline
						multilineRows={4}
						label={t('detailsStep.label')}
					/>
				)}
			/>
		</div>
	)
}

export default AdditionalDetailsStep
